import React from "react";
import { Modal, Button } from "react-bootstrap";

const ConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  title = "Confirm Action",
  description = "Are you sure you want to perform this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "primary", // default button variant
  size = "md", // default modal size
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size={size}
      contentClassName="p-4 border-0"
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-2 text-muted">{description}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onHide} className="btn-main">
          {cancelText}
        </Button>
        <Button variant={variant} onClick={onConfirm} className="btn-main">
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
